export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const API_ENDPOINTS = {
  AUTH: {
    GOOGLE: '/users/auth/google/',
    LOGOUT: '/auth/logout/',
  },
  USERS: {
    PROFILE: '/users/profile/',
    LIST: '/users/',
  },
  ATTENDANCE: {
    LIST: '/attendance/',
    CREATE: '/attendance/',
    STATS: '/attendance/stats/',
  },
};